import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import ConsumerLayout from '../consumer-layout/ConsumerLayout';
import PageWthConfirmation from '../page-with-confirmation/PageWthConfirmation';
import { consumerScoutFinalMessages } from '../../redux/consumer/scout/consumerScoutActions';
import Header from './components/header/Header';
import MessagesList from './components/messages-list/MessagesList';

function ScoutFinalMessages() {
  const { projectName } = useParams();
  const dispatch = useDispatch();

  const isConfirmed = useSelector((state) => state.consumer.isConfirmed);
  const messagesContent = useSelector((state) => state.scout.messagesContent);

  const handleConfirmFinalMessages = async (values) => {
    await dispatch(consumerScoutFinalMessages({ projectName, projectPassword: values.password }));
  };

  return (
    <PageWthConfirmation isConfirmed={isConfirmed} onConfirm={handleConfirmFinalMessages}>
      <ConsumerLayout Header={Header()}>
        <MessagesList content={messagesContent} />
      </ConsumerLayout>
    </PageWthConfirmation>
  );
}

export default ScoutFinalMessages;
